var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookings2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66597 7.49688C2.32874 7.49688 2.96436 7.76016 3.433 8.22881C3.90165 8.69745 4.16493 9.33307 4.16493 9.99584C4.16493 10.6586 3.90165 11.2942 3.433 11.7629C2.96436 12.2315 2.32874 12.4948 1.66597 12.4948V14.1608C1.66597 14.6026 1.8415 15.0264 2.15393 15.3388C2.46636 15.6512 2.8901 15.8267 3.33195 15.8267H16.6597C17.1016 15.8267 17.5253 15.6512 17.8377 15.3388C18.1502 15.0264 18.3257 14.6026 18.3257 14.1608V12.4948C17.6629 12.4948 17.0273 12.2315 16.5587 11.7629C16.09 11.2942 15.8267 10.6586 15.8267 9.99584C15.8267 9.33307 16.09 8.69745 16.5587 8.22881C17.0273 7.76016 17.6629 7.49688 18.3257 7.49688V5.8309C18.3257 5.38906 18.1502 4.96531 17.8377 4.65288C17.5253 4.34045 17.1016 4.16493 16.6597 4.16493H3.33195C2.8901 4.16493 2.46636 4.34045 2.15393 4.65288C1.8415 4.96531 1.66597 5.38906 1.66597 5.8309V7.49688Z",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8288 4.16493V5.8309",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8288 14.1608V15.8267",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8288 9.16286V10.8288",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9917,
    height: 19.9917,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings2);
export default __webpack_public_path__ + "static/media/Bookings2.9be737ea8a70c9ae503594578b1c5a8b.svg";
export { ForwardRef as ReactComponent };